module.exports = __webpack_public_path__ + "img/logo.fcc86865.png";